<script setup>
import MediaList from '@/components/common/ListDialog.vue'
import MediaExList from '@/components/media/MediaExList.vue';
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card flat outlined class="mt-3">
<MediaExList ref="ex" v-on:open="listopen($event)" />
<MediaList ref="mlist" :list_id="selected_id" :list_title="selected_title" />
    <v-card-title>
        <h2 class="ranking_head">メディアリスト</h2>
    </v-card-title>
    <v-card-text>
      <v-list
       dense>
        <v-list-item
          v-for="item,index in items"
          :key="item.title"
          link
          @click="menu_link(index)"
        >
        <v-badge
            :content="candlist.length"
            :value="candlist.length"
            color="error"
            overlap
            style="display:flex!important;width:100%;"
			v-if="index==0"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-badge>
		<template v-else>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
		</template>
        </v-list-item>
      </v-list>
    </v-card-text>
</v-card>
</template>
<script>
export default {
    computed : {
        candlist : function(){
            return this.$store.getters["mediacand/get_candlist"];
		},
	},
	data : function(){
		return {
		selected_id : "",
		selected_title : "",
        items: [
          { title: '候補BOXを開く', icon: 'mdi-bookmark-box' },
          { title: 'リストを編集する', icon: 'mdi-playlist-edit' },
        ],

		};
	},
	methods : {
		listopen  : function(data){
			this.selected_id=data.list_id;
			this.selected_title = data.list_title;
			this.$nextTick(function(){
				this.$refs.mlist.open();
			});
		},
        menu_link : function(index){
            switch(index)
            {
            case 0:
				this.selected_id="";
				this.selected_title="";
                this.$refs.mlist.open();
				break;
			case 1:
                this.$refs.ex.open(1);
				break;
            default :
                this.$refs.mlist.open();
            }
        },
	},
	created : async function(){
        let params = new URLSearchParams();
        await axios.post("/api/media/get_media_list",params)
        .then(response => {
            this.$store.commit("mediacand/set_candlist",response.data);
        }).catch((error) => {
//            window.location.href = 'https://qlipper.jp/login';
            console.error('失敗です', error);
        });
	},
}
</script>
